import { useEffect } from "react";
import { playProjectsIntro } from "../animations/projectsPageAnimation";

export default function Projects() {
  useEffect(() => {
    playProjectsIntro();
  }, []);

  return (
    <main className="relative min-h-screen px-24 py-32 text-neutral-300 bg-gradient-to-br from-[#0a0a0a] via-[#12080b] to-black overflow-hidden">
      <div
        id="time-freeze"
        className="fixed inset-0 z-30 pointer-events-none
                   bg-blue-500/20 backdrop-blur-[2px] opacity-0"
      />

      <div id="projects-content" className="max-w-xl">
        <h1 className="text-xs tracking-widest uppercase mb-6 opacity-70">
          Projects
        </h1>

        <p className="text-4xl text-white mb-4 leading-tight">
          Publishing soon.
        </p>

        <p className="opacity-60">Time is still frozen.</p>
        <p className="opacity-30">
          For now, check my GitHub{" "}
          <a
            href="https://github.com/tatiane-kelli"
            target="_blank"
            rel="noreferrer"
            className={({ isActive }) =>
              isActive ? "text-white" : "hover:text-white transition"
            }
          >
            clicking here.
          </a>
        </p>
      </div>

      <div className="absolute right-[30%] top-1/2 h-[60%] w-px bg-neutral-700/40 -translate-y-1/2" />
    </main>
  );
}
